export const checkSelected = (collections, selectedValues) =>
    collections.map((collection) => ({
        ...collection,
        checked: Boolean(selectedValues && selectedValues.includes(collection.key))
    }));
